// extracted by mini-css-extract-plugin
export default {"auth_container":"AuthComponent_auth_container__98D6g","form_container":"AuthComponent_form_container__Zyizi","header":"AuthComponent_header__T+Gl2"};